/**
 * CountryIcon - Muestra icono de assets/passport si existe, si no la bandera emoji.
 * Rutas probadas: assets/passport/{slug(nombre)}.png y assets/passport/{código}.png
 * Ej: japan.png, jp.png
 */

import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { getPassportIconUrls, getFlag } from "./passportIconUtils";

/**
 * @param {string} countryCode - Código ISO (ej. JP)
 * @param {string} countryName - Nombre del país (ej. Japan)
 * @param {object} sx - Estilos MUI para el contenedor del icono
 * @param {string|object} imgSx - Estilos para la imagen (tamaño, etc.)
 * @param {string} size - 'sm' | 'md' | 'lg' para emoji/fallback
 * @param {boolean} lightOnDark - Si true y es imagen, se muestra en blanco (para fondos oscuros)
 */
function CountryIcon({ countryCode, countryName, sx = {}, imgSx = {}, size = "md", lightOnDark = false }) {
	const urls = getPassportIconUrls(countryCode, countryName);
	const [tryIndex, setTryIndex] = useState(0);
	const flag = getFlag(countryCode);

	const handleError = () => {
		if (tryIndex < urls.length - 1) {
			setTryIndex((i) => i + 1);
		} else {
			setTryIndex(-1);
		}
	};

	// Mostrar bandera emoji si no hay URLs o todas fallaron
	if (urls.length === 0 || tryIndex === -1) {
		const fontSize =
			size === "sm" ? { xs: "1rem", sm: "1.2rem" } : size === "lg" ? { xs: "1.6rem", sm: "1.8rem" } : { xs: "1.4rem", sm: "1.6rem" };
		return (
			<Typography sx={{ fontSize, lineHeight: 1, ...sx }}>
				{flag}
			</Typography>
		);
	}

	// Cuando es imagen (no bandera), la mostramos un poco más grande
	const imgBase = size === "sm" ? 28 : size === "lg" ? 44 : 36;
	const imgSxFinal = {
		display: "block",
		objectFit: "contain",
		width: imgBase,
		height: imgBase,
		...(lightOnDark ? { filter: "brightness(0) invert(1)" } : {}),
		...imgSx,
		...sx,
	};
	return (
		<Box
			component="img"
			src={urls[tryIndex]}
			alt=""
			onError={handleError}
			sx={imgSxFinal}
		/>
	);
}

export default CountryIcon;
